import { Link as VCCLink } from '@vcc-www/buttons';

type LinkProps = {
  href: string;
  children: string;
  trackingEventLabel?: string;
};

const Link: React.FC<LinkProps> = ({ href, children, trackingEventLabel }) => (
  <VCCLink
    href={href}
    trackEventAction="link|click"
    trackEventLabel={trackingEventLabel ?? href}
    extend={({ theme: { baselineGrid } }) => ({ marginTop: baselineGrid })}
  >
    {children}
  </VCCLink>
);

export default Link;
